let ss = {}
function stats(key) {
	let s = ss[key]
	if (!s) {
		s = { time: 0, recomputations: 0 }
		ss[key] = s
	}
	return s
}
stats.all = () => ss
stats.clear = () => ss = {}

export default stats



// WEBPACK FOOTER //
// ./src/utils/redux/stats.js